// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__313AZ","upload":"Small_upload__1mTtR","imageWrap":"Small_imageWrap__1y_fi","removeBtn":"Small_removeBtn__s6rw0"};